module.exports = __webpack_public_path__ + "static/media/production_calendar.d0bcee9d.svg";